import { Fragment } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Spinner from "../layout/Spinner";
import { Stack } from "@mui/material";
import { LabelText } from "../Common/Typography/AppTypography";
import AppButton from "../Common/Button/Button";

const HomeItem = ({ home: { home, loading }, homeData }) => {
  let navigate = useNavigate();

  if (!home) {
    return <Spinner />;
  }

  return loading || home === null ? (
    <Spinner />
  ) : (
    <Fragment>
      {homeData && homeData.length > 0 ? (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {homeData.map((homeItem) => (
            <NavLink
              key={homeItem.homeId}
              to={`/report/${homeItem.homeId}`}
              className={({ isActive }) =>
                isActive ? "selectedLink" : undefined
              }
              style={{ textDecoration: "none" }}
            >
              <AppButton
                size="small"
                variant="primary"
                sx={{ minWidth: "auto", px: 1.25 }}
              >
                {homeItem.homeName || homeItem.homeId}
              </AppButton>
            </NavLink>
          ))}
        </Stack>
      ) : (
        <LabelText sx={{ color: "error.main" }}>
          You have not yet setup a home, please add some information
        </LabelText>
      )}
    </Fragment>
  );
};

export default HomeItem;
